// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"79ca5419","453":"7a75fd5d"}[chunkId] + ".chunk.js";
};